import * as apiClient from '../api/apiClient';
import { buildPagedQuery } from '../api/pagedQuery';
import { pageInMemoryList } from '../api/localPagedList';
import { unwrapPagedResponseModel, unwrapResponseModel } from '../api/responseModel';

const INDEX_PATH = '/api/cur/Index';

async function requestAndUnwrap(requestPromise) {
  const { data } = await requestPromise;
  return unwrapResponseModel(data);
}

export function resetCursadasListCacheForTests() {
  // Sin caché deduplicada tras F4-011.
}

export function listCursadas(query = { page: 1, pageSize: 10 }) {
  const qs = buildPagedQuery(query);
  return apiClient.get(`${INDEX_PATH}?${qs}`).then(({ data }) => unwrapPagedResponseModel(data));
}

export function lookupCursadas(query = { page: 1, pageSize: 5 }) {
  return listCursadas(query);
}

export function getCursada(id) {
  return requestAndUnwrap(apiClient.get(`/api/cur/${id}`));
}

export function deleteCursada(id) {
  return requestAndUnwrap(apiClient.get(`/api/cur/delete/${id}`));
}

export function saveCursada(payload) {
  return requestAndUnwrap(apiClient.post('/api/cur', payload));
}

export function listCursadasActivas(carreraId) {
  return requestAndUnwrap(apiClient.get(`/api/cur/activas/${carreraId}`));
}

export async function listCursadasActivasPaged(carreraId, query = { page: 1, pageSize: 5 }) {
  const items = await listCursadasActivas(carreraId);
  return pageInMemoryList(items, query);
}

export function listCursadasActivasForAlumno(carreraId, alumnoCarreraCod) {
  return requestAndUnwrap(apiClient.get(`/api/cur/activas/${carreraId}/${alumnoCarreraCod}`));
}

export async function listCursadasActivasForAlumnoPaged(carreraId, alumnoCarreraCod, query = { page: 1, pageSize: 5 }) {
  const items = await listCursadasActivasForAlumno(carreraId, alumnoCarreraCod);
  return pageInMemoryList(items, query);
}

export function generarCursadas(payload) {
  return requestAndUnwrap(apiClient.post('/api/cur/gen', payload));
}

export function generarActaCursada(cursadaCod) {
  return requestAndUnwrap(apiClient.get(`/api/acur/generate/${cursadaCod}`));
}
